<template>
   <div class="num-action" ref="myBox">
      <div class="item">
        <div class="top"><span id="counter1" ref="box1">{{ state.amount1 }}</span> <span>{{ $t('stats.unitPerson') }}</span></div>
        <div class="down">{{ $t('stats.peacockTalent') }}</div>
      </div>
      <div class="item">
        <div class="top"><span id="counter2" ref="box2">{{ state.amount2 }}</span>  <span>+</span> </div>
        <div class="down">{{ $t('stats.patents') }}</div>
      </div>
      <div class="item">
        <div class="top"><span id="counter3" ref="box3">{{ state.amount3 }}</span><span>{{ $t('stats.unitYear') }}</span> </div>
        <div class="down">{{ $t('stats.projects') }}</div>
      </div>
    </div>
  </template>
  <script setup>
import { reactive,ref,onMounted  } from 'vue';
const { $aos } = useNuxtApp()
const myBox = ref(null);
const box1 = ref(null)
const box2 = ref(null)
const box3 = ref(null)
const state =reactive({
  amount1:0,
  amount2:0,
  amount3:0
})
function animateValue(id, start, end, duration) {
  let current = start;
  const increment = Math.floor((end - start) / duration * 10);

  const obj = document.getElementById(id);
  const timer = setInterval(() => {
    current += increment;
    obj.textContent = current;

    if (current >= end) {
      clearInterval(timer);
      obj.textContent = end;
    }
  }, 80);
}

  onMounted(() => {
   // 检测元素是否在视图窗口的函数
   const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // 当元素进入视窗口时触执行这里面的代码
        animateValue('counter1', 0, 5, 50); // 示例：从 0 到 5，持续时间为 200ms
        animateValue('counter2', 0, 30, 160);
        animateValue('counter3', 0, 10, 100);
      }
    });
  });
  observer.observe(myBox.value);
  $aos().init({
    easing: 'ease-out-back',
    duration: 2000,
  })
})
  </script>
  
  <style lang="less" scoped>
   .num-action{
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    padding: 20px 0;
    .item{
      .top{
        margin-bottom: 10px;
        color: #00a0e8;
        #counter1{
          font-size: 20px;
        }
        #counter2{
          font-size: 20px;
        }
        #counter3{
          font-size: 20px;
        }
        span{
          font-size: 12px;
        }
      }
    }
  }
  </style>
  